import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { BehaviorSubject, Observable, throwError } from 'rxjs'
import { catchError, filter, switchMap, take } from 'rxjs/operators'
import { AuthenticationService } from '../service/auth.service'

const ENDPOINTS_SEM_REFRESH = ['/auth/login', '/auth/login-externo', '/auth/refresh', '/auth/verificar-codigo-2fa']

@Injectable()
export class TokenRefreshInterceptor implements HttpInterceptor {
  private authService = inject(AuthenticationService)

  private refreshing = false
  private tokenAtualizado$ = new BehaviorSubject<string | null>(null)

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && this.deveTentarRefresh(request)) {
          return this.tratar401(request, next)
        }
        return throwError(() => error)
      })
    )
  }

  private deveTentarRefresh(request: HttpRequest<unknown>): boolean {
    if (ENDPOINTS_SEM_REFRESH.some((endpoint) => request.url.includes(endpoint))) {
      return false
    }
    return !!this.authService.getRefreshToken()
  }

  private tratar401(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.refreshing) {
      return this.tokenAtualizado$.pipe(
        filter((token): token is string => token !== null),
        take(1),
        switchMap((token) => next.handle(this.adicionarToken(request, token)))
      )
    }

    this.refreshing = true
    this.tokenAtualizado$.next(null)

    return this.authService.refreshToken().pipe(
      switchMap((response) => {
        this.refreshing = false
        this.tokenAtualizado$.next(response.token)
        return next.handle(this.adicionarToken(request, response.token))
      }),
      catchError((refreshError) => {
        this.refreshing = false
        this.authService.limparSessaoLocal()
        return throwError(() => refreshError)
      })
    )
  }

  private adicionarToken(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
    return request.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    })
  }
}
